/**
 * 헤더 알림 종 배지용 미읽음 개수(/api/notifications/my/unread-count)를 즉시 다시 조회하도록 요청합니다.
 * 실제 API 호출은 HeaderTop의 단일 리스너에서 수행합니다.
 */
export const NOTIFICATION_UNREAD_COUNT_REFRESH_EVENT = 'glow:requestNotificationUnreadCountRefresh';

export function requestNotificationUnreadCountRefresh() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(NOTIFICATION_UNREAD_COUNT_REFRESH_EVENT));
  }
}
